import { COUNTRY_SETTINGS } from "./constants";
export const getCountrySetting = (countryCode) => {
  const countrySetting = COUNTRY_SETTINGS[countryCode] || COUNTRY_SETTINGS['DEFAULT'];
  return countrySetting;
};

export const convertToCurrency = (amount, countrySetting) => {
  let amountAfterCurrencyConversion = Math.ceil(parseFloat(amount) * countrySetting.exchangeRate);
  if(countrySetting.currencyCode !== 'AUD'){
    amountAfterCurrencyConversion =  Math.round(amountAfterCurrencyConversion / 100) * 100;
  }
  return amountAfterCurrencyConversion;
};

export const calculatePriceWithDiscount = (price, coupon) => {
  const discount_amount = coupon.discount_type === 'fixed_amount' ? coupon.discount_amount : (price * coupon.discount_percentage) / 100;
  return discount_amount > price ? 0 : price - discount_amount; 
};

export const checkIfDiscountIsApplicableForProduct = (selectedPlan, product, coupon, isDiscountAppliedAlready) => {
  const isDiscountApplicableForTheProduct = !coupon.isValid || isDiscountAppliedAlready || coupon.apply_on === 'invoice_amount' || !coupon.meta_data?.plan_ids?.includes(selectedPlan) || coupon.addon_constraint === 'none' || (coupon.addon_constraint === 'specific' && !coupon.addon_ids?.includes(product)) ? false: true;
  return isDiscountApplicableForTheProduct;
}

export const getTotalDiscountedAmount = (plan, products, isDiscountAppliedOnPlan)=> {
  if(isDiscountAppliedOnPlan){
    return plan.originalPrice - plan.price;
  }
  const productsTotalOriginalAmount = products.reduce(
    (total, product) => total + product.originalPrice * product.quantity,
    0
  );
  const productsTotalDiscountedAmount = products.reduce(
    (total, product) => total + product.price * product.quantity,
    0
  );

  return productsTotalOriginalAmount - productsTotalDiscountedAmount;
};

export const getShippingOptions = (countrySetting) => {
  return countrySetting.shippingOptions.map((shippingOption)=> {
    return {
      ...shippingOption,
      priceInSelectedCurrency: convertToCurrency(shippingOption.price, countrySetting) / 100
    }
  });
}